const config = {
  languages: ['ro', 'ru', 'en'],
  defaultLanguage: 'ro',
};

export default config;
